export const labels = {
  LabelAccountReport: {
    default: [
      'LabelName',
      'Impressions',
      'Clicks',
      'CTR',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
    mandatory: [
      'Impressions',
    ],
  },
  LabelCampaignReport: {
    default: [
      'LabelName',
      'Impressions',
      'Clicks',
      'CTR',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
    mandatory: [
      'Impressions',
    ],
  },
  LabelAdGroupReport: {
    default: [
      'LabelName',
      'Impressions',
      'Clicks',
      'CTR',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
    mandatory: [
      'Impressions',
    ],
  },
  LabelKeywordReport: {
    default: [
      'LabelName',
      'Impressions',
      'Clicks',
      'CTR',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
    mandatory: [
      'Impressions',
    ],
  },
  LabelAdReport: {
    default: [
      'LabelName',
      'Impressions',
      'Clicks',
      'CTR',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
    mandatory: [
      'Impressions',
    ],
  },
};
